// extracted by mini-css-extract-plugin
module.exports = {"read":"styles-styles-module--read--3y7pF"};